<template>
  <div
    class="bb-settings-categories-project-step-item"
    :class="[isHover && 'bb-settings-categories-project-step-item_active']"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <div>
      <div
        v-if="isHover"
        class="bb-settings-categories-project-step-item__drop"
        v-html="MoveIcon()"
      />
    </div>
    <div
      class="bb-settings-categories-project-step-item__counter"
      :style="{
        color: `rgba(${item.color}, 1)`,
        background: `rgba(${item.color}, 0.15)`
      }"
    >
      {{index + 1}}
    </div>
    <ExpenseCategoriesListOfProjectStepItemInput
      :item="item"
      @onEdit="onEdit"
      @resetError="resetError"
    />
    <ExpenseCategoriesListOfProjectStepItemPercent
      :item="item"
      @onEdit="onEdit"
    />
    <div>
      <div
        v-if="isHover"
        class="bb-settings-categories-project-step-item__color"
      >
        <div
          class="bb-settings-categories-project-step-item__icon"
          :style="{
            color: `rgba(${item.color}, 1)`,
            background: `rgba(${item.color}, 0.15)`
          }"
          v-html="BackgroundIcon()"
          @click="onOpenColorPicker($event)"
        />
      </div>
    </div>
    <template v-if="isHover">
      <div
        v-if="!item.isAssignedProject"
        class="bb-settings-categories-project-step-item__delete"
      >
        <img
          src="@/assets/images/icon-delete.png"
          @click="onDelete"
        />
      </div>
      <div
        v-else
        class="bb-settings-categories-project-step-item__info"
        v-html="ExclamationIcon()"
        @mouseenter="onMouseenterInfo($event)"
        @mouseleave="onMouseleaveInfo"
      />
    </template>
  </div>
</template>

<script>
import { BackgroundIcon, MoveIcon, ExclamationIcon } from '@/constants/icon'
import ExpenseCategoriesListOfProjectStepItemInput
  // eslint-disable-next-line max-len
  from '@/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProjectStep/ExpenseCategoriesListOfProjectStepItemInput'
import ExpenseCategoriesListOfProjectStepItemPercent
  // eslint-disable-next-line max-len
  from '@/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProjectStep/ExpenseCategoriesListOfProjectStepItemPercent'

export default {
  name: 'ExpenseCategoriesListOfProjectStepItem',
  components: {
    ExpenseCategoriesListOfProjectStepItemInput,
    ExpenseCategoriesListOfProjectStepItemPercent
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    hover: {
      type: String,
      default: ''
    },
    draggable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    BackgroundIcon,
    MoveIcon,
    ExclamationIcon
  }),
  computed: {
    isHover () {
      return this.draggable ? false : this.hover === this.item._id || this.item.isNew
    }
  },
  methods: {
    onMouseenterInfo ({ target }) {
      this.$emit('onShowInfo', target)
    },
    onMouseleaveInfo () {
      this.$emit('onShowInfo')
    },
    onDelete () {
      this.$emit('onDelete', this.item, this.index)
    },
    onEdit () {
      this.$emit('onEdit', this.item, this.index)
    },
    onOpenColorPicker (event) {
      this.$emit('onOpenColorPicker', this.item, this.index, event)
    },
    mouseenter () {
      this.$emit('update:hover', this.item._id)
    },
    mouseleave () {
      this.$emit('update:hover', '')
    },
    resetError () {
      this.$emit('resetError')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bb-settings-categories-project-step-item {
    height: 54px;
    padding: 0 14px 0 14px;
    display: grid;
    align-items: center;
    grid-template-columns: 9px 23px 1fr 110px 64px 24px;
    grid-gap: 0 12px;
    border-top: 1px solid $color-concrete;

    &_active {
      box-shadow: 0 0 12px rgba($color-black, 0.12);
      border-radius: 5px;
      border-top-color: transparent;
    }

    &__drop {
      display: flex;
      cursor: grab;
    }

    &__counter {
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba($color-accent, 0.15);
      border-radius: 50%;
      font-size: 10px;
      line-height: 13px;
      font-weight: 600;
      color: $color-denim;
      white-space: nowrap;
      height: 19px;
      width: 19px;
    }

    &__color {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
    }

    &__icon {
      width: 21px;
      height: 21px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: rgba($color-denim, 0.15);
    }

    &__delete {
      width: 21px;
      height: 21px;
      cursor: pointer;
      transition: 0.15s;

      img {
        height: 100%;
        width: 100%;
      }
    }

    &__info {
      display: flex;
      justify-content: center;
      align-items: center;
      color: $color-silver-chalice;
      cursor: pointer;
      transition: 0.2s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProjectStep/ExpenseCategoriesListOfProjectStepItem.vue